import React from 'react'

const DrugsIcon = props => (
  <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.3">
      <path
        d="M1.37823 4.83891C0.426087 5.79106 0.426087 7.33421 1.37823 8.28561C1.85412 8.76187 2.47776 9 3.10177 9C3.72578 9 4.34942 8.76187 4.82531 8.28599L6.6891 6.4222L3.24202 2.97512L1.37823 4.83891Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M8.95041 0.713828C7.99902 -0.237943 6.45511 -0.237943 5.50371 0.713828L3.63992 2.57762L7.087 6.02469L8.95079 4.1609C9.90256 3.20876 9.90256 1.6656 8.95041 0.713828Z"
        fill="url(#paint1_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="3.67661"
        y1="2.97512"
        x2="3.67661"
        y2="9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="6.65224"
        y1="0"
        x2="6.65224"
        y2="6.02469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default DrugsIcon
